import { BehaviorSubject, fromEvent, switchMap } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

import { Directive, ElementRef, inject, Input, Output } from '@angular/core';

import { LifecycleHooks } from '@app/core/services/lifecycle-hooks.service';
import { NzTableComponent } from 'ng-zorro-antd/table';

@Directive({ selector: '[adsptScrollToBottom]', providers: [LifecycleHooks] })
export class ScrollToBottomDirective {
  readonly table = inject(NzTableComponent, { optional: true, self: true });

  @Input()
  set scrollBottomTarget(target: string) {
    this.scrollBottomTarget$.next(target);
  }

  readonly scrollBottomTarget$ = new BehaviorSubject('');

  @Output('adsptScrollToBottom')
  readonly scrollToBottom$ = this.scrollBottomTarget$.pipe(
    debounceTime(1),
    map((target) =>
      target
        ? this.el.nativeElement.closest(target)
        : this.table?.nzTableInnerScrollComponent?.tableBodyElement.nativeElement || this.el.nativeElement,
    ),
    switchMap((target: HTMLElement) =>
      fromEvent(target, 'scroll').pipe(
        map(() => target.scrollTop + target.offsetHeight >= target.scrollHeight - 2),
        distinctUntilChanged(),
        filter((bottomReached) => bottomReached),
      ),
    ),
  );

  constructor(private el: ElementRef<HTMLElement>) {}
}
